// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_3m-2";
export var cell = "_3m-6";
export var cellContainer = "_3m-3";
export var disabled = "_3m-5";
export var featuredIconCellContainer = "_3m-7";
export var featuredIconTextContainer = "_3m-9";
export var featuredIconWrapper = "_3m-8";
export var hasRowsSelected = "_88-1";
export var noBorder = "_3m-a";
export var overflowableText = "_3m-0";
export var overflowableTextContainer = "_3m-1";
export var row = "_3p-0";
export var rowCheckboxCell = "_3m-4";
export var selectableTable = "_88-2";